import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import {
  beneLookUp,
  viewAccountDetail,
} from "../../../../redux/features/verifyPAN/verifyPAN";
import StatusContainer from "../../../../components/_utils/CommonStatus/StatusContainer";
import TabsWeapperSection from "../../../../components/_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import InfoCard from "../../../../components/_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import CommonToast from "../../../../components/_utils/CommonToast";
import { beneBankLookUp } from "../../../../redux/features/beneficiary/beneAllVerification/beneAllVerification";

import SmallPopupWithInput from "../../../../components/_utils/CommonSmallPopupWithInput";
import ICONS from "../../../../assets/Icons";
import { setHideBreadCrumb } from "../../../../redux/features/hideBreadCrumb/hideBreadCrumb";
import accountNameStandardised from "../../../../utils/accountNamestandardised";
import { GlobalConfiguration } from "../../../../utils/configurationProvider";

const BeneEditSucess = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { id, successType } = useParams();

  const updatedFields = location?.state?.updatedFields || [];

  const [currentAccountDetails, setCurrentAccountDetails] = useState({
    id: "",
    name: "",
    bank_name: "",
    bank_acc_no: "",
    ifsc_code: "",
    category: "",
    pan: "",
    labels: "",
  });

  const { viewAccountDetailData } = useSelector((state) => state.verify);

  const accountData = viewAccountDetailData?.beneficiary_accounts[0];

  const contactFieldConfig = {
    account_name: {
      leftSubTitle: "Account name",
      getTitle: (acc) =>
        acc?.name ? accountNameStandardised(acc.name) : "Not available",
    },
    contact_no: {
      leftSubTitle: "Contact number",
      icon: ICONS.CONTACT_NO,
      getTitle: (acc) =>
        acc?.contact_no ? `+91 ${acc.contact_no}` : "Not available",
    },
    email_id: {
      leftSubTitle: "Email ID",
      icon: ICONS.GMAIL_RED_ERROR,
      getTitle: (acc) => acc?.email_id || "Not available",
    },
  };

  const categoryFieldConfig = {
    category: {
      leftSubTitle: "Assigned categories",
      getTitle: (acc) => acc?.category || "Not assigned",
    },
  };

  const getFieldsToShow = () => {
    if (updatedFields.length > GlobalConfiguration.lengthCheckZero) {
      return updatedFields;
    }
    if (successType === "contact_edit_success") {
      return ["account_name", "contact_no", "email_id"];
    }
    if (successType === "category_edit_success") {
      return ["category"];
    }
    return null;
  };

  const fieldsToShow = getFieldsToShow();
  const showOnlyUpdated =
    fieldsToShow &&
    (successType === "contact_edit_success" ||
      successType === "category_edit_success");

  const getSuccessTitle = () => {
    if (successType === "category_edit_success") {
      return "Beneficiary categories updated successfully.";
    }
    if (successType === "contact_edit_success") {
      const hasContactUpdate = updatedFields.some((f) =>
        ["contact_no", "email_id"].includes(f),
      );
      const hasNameUpdate = updatedFields.includes("account_name");
      if (hasNameUpdate && !hasContactUpdate)
        return "Account name updated successfully.";
      if (hasContactUpdate && !hasNameUpdate)
        return "Contact details updated successfully.";
      if (hasNameUpdate && hasContactUpdate)
        return "Account details updated successfully.";
    }
    return "Details updated successfully.";
  };

  const renderInfoCards = () => {
    if (successType === "contact_edit_success") {
      return fieldsToShow
        .filter((key) => contactFieldConfig[key])
        .map((key) => {
          const config = contactFieldConfig[key];
          return (
            <InfoCard
              key={key}
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: config.getTitle(accountData),
                  leftSubTitle: config.leftSubTitle,
                  ...(config.icon && { icon: config.icon }),
                },
              ]}
            />
          );
        });
    }
    if (successType === "category_edit_success") {
      return fieldsToShow
        .filter((key) => categoryFieldConfig[key])
        .map((key) => {
          const config = categoryFieldConfig[key];
          return (
            <InfoCard
              key={key}
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: config.getTitle(accountData),
                  leftSubTitle: config.leftSubTitle,
                },
              ]}
            />
          );
        });
    }
    return null;
  };

  useEffect(() => {
    dispatch(setHideBreadCrumb({ hide: true }));

    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [dispatch]);

  useEffect(() => {
    if (accountData) {
      const {
        id,
        name,
        bank_name,
        bank_acc_no,
        ifsc_code,
        category,
        pan_no,
        labels,
      } = accountData;
      setCurrentAccountDetails({
        id,
        name,
        bank_name,
        bank_acc_no,
        ifsc_code,
        category,
        pan: pan_no,
        labels: labels,
      });
    }
  }, [accountData]);

  const createTxnHandler = () => {
    navigate(
      "/beneficiary_transaction_dashboard/create_beneficiary_transaction",
      {
        state: currentAccountDetails,
      },
    );
  };

  const viewDetailsHandler = () => {
    navigate(
      `/beneficiary_account_dashboard/beneficiary_account_view_all/beneficiary_account_detail_page/${id}`,
    );
  };

  const dashboardHandler = () => {
    navigate("/beneficiary_account_dashboard");
  };

  const createAccountHandler = () => {
    navigate("/beneficiary_account_dashboard/create_beneficiary_account");
  };

  useEffect(() => {
    dispatch(viewAccountDetail({ id }));
  }, [id, dispatch]);

  useEffect(() => {
    if (!accountData) return;

    dispatch(beneLookUp({ pan_number: accountData.pan_no }));

    dispatch(
      beneBankLookUp({
        ifsc: accountData.ifsc_code,
        bank_account_no: accountData.bank_acc_no,
      }),
    );
  }, [accountData, dispatch]);
  const buttonRows = [
    [
      {
        btnText: "Create account",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: "https://q2pay.in/new_assets/common/create_flow/create_new_account.svg",
        handleFunction: createAccountHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },
      {
        btnText: "Create transaction",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: ICONS.ADD_BUTTON,
        handleFunction: createTxnHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },
      {
        btnText: "View details",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: ICONS.VIEW_DETAILS,
        handleFunction: viewDetailsHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },
    ],

    [
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--bg-positive-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: ICONS.DASHBOARD,
        handleFunction: dashboardHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
      },
    ],
  ];

  return (
    <div>
      <StatusContainer
        status="success"
        buttonRows={buttonRows}
        title={getSuccessTitle()}
        // subtitle={
        //   successType === "category_edit_success"
        //     ? "Categories updated successfully."
        //     : null
        // }
      >
        <TabsWeapperSection title="Account details">
          <>
            {showOnlyUpdated ? (
              renderInfoCards()
            ) : (
              <>
                <InfoCard
                  bgColor="var(--positive-card)"
                  rows={[
                    {
                      leftTitle: accountData?.category,
                      leftSubTitle: "Assigned categories",
                    },
                  ]}
                />
                <InfoCard
                  bgColor="var(--positive-card)"
                  rows={[
                    {
                      leftTitle: accountNameStandardised(accountData?.name),
                      leftSubTitle: "Account name",
                    },
                  ]}
                />
                <InfoCard
                  bgColor="var(--positive-card)"
                  rows={[
                    {
                      leftTitle: accountData?.pan_no,
                      leftSubTitle: "PAN number",
                    },
                  ]}
                />
                <InfoCard
                  bgColor="var(--positive-card)"
                  rows={[
                    {
                      leftTitle: accountData?.bank_acc_no,
                      leftSubTitle: "Account number",
                      ifsc: accountData?.ifsc_code,
                    },
                  ]}
                />
                <InfoCard
                  bgColor="var(--positive-card)"
                  rows={[
                    {
                      leftTitle: accountData?.ifsc_code,
                      leftSubTitle: "IFSC code",
                    },
                  ]}
                />
                <InfoCard
                  bgColor="var(--positive-card)"
                  rows={[
                    {
                      leftTitle: accountData?.contact_no,
                      leftSubTitle: "Contact number",
                      icon: ICONS.CONTACT_NO,
                    },
                  ]}
                />
                <InfoCard
                  bgColor="var(--positive-card)"
                  rows={[
                    {
                      leftTitle: accountData?.email_id,
                      leftSubTitle: "Email ID",
                      icon: ICONS.GMAIL_RED_ERROR,
                    },
                  ]}
                />
              </>
            )}
          </>
        </TabsWeapperSection>
      </StatusContainer>
    </div>
  );
};

export default BeneEditSucess;
